module.exports = __webpack_public_path__ + "media/images/common/logo_privacy_10820770_200_jp-a9696a39665928e316ceb5f35582e525.png";